import {
  Component, ChangeDetectorRef, ChangeDetectionStrategy, Input,
  ViewChild, Output, EventEmitter, OnDestroy,
} from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';


import { SearchModel } from './ymm-search.model';

import { FrontendSearchWidgetComponent } from 'shared/search-widget/frontend-search-widget.component';
import { HiddenScrollComponent } from 'shared/scroll/hidden-scroll/hidden-scroll.component';
import { LoaderComponent } from 'shared/loader/loader.component';

import { FitmentsService } from 'shared/fitments/fitments.service';
import {takeWhile} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'fitment-ymm-search',
  templateUrl: 'fitment-ymm-search.component.html',
  styleUrls: ['fitment-ymm-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FitmentYmmSearchComponent extends FrontendSearchWidgetComponent implements OnDestroy {
  @Input() sortingColumns: Array<any>;

  @Output() selectFitments: EventEmitter<Array<any>> = new EventEmitter<any>();

  @ViewChild(LoaderComponent, {static: false})
  loader: LoaderComponent | void;

  searchModel: SearchModel = new SearchModel();
  debounceSearching: any = _.debounce(this.searching, 500);
  private isActive: boolean = true;

  constructor(
    private fitmentsService: FitmentsService,
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnDestroy() {
    this.isActive = false;
  }

  onCheckboxChanged(row: any) {
    this.selectedAll = false;
    if (row.selected) {
      if (_.findIndex(this.selectedData, ['id', row.id]) === -1) {
        this.selectedData.push(row);
      }
    } else {
      _.pullAllBy(this.selectedData, [row], 'id');
    }
  }

  onAssignClick() {
    this.selectFitments.emit(this.selectedData);
  }

  onPaginationBtnClick(direction: number) {
    this.searchModel.currentPage += direction;
    this.debounceSearching(this.searchModel.searchString);
  }

  public searching(searchString: string) {
    if (!searchString) {
      this.searchModel = new SearchModel();
      this.data = [];
      this.selectedData = [];
      this.selectedAll = false;
      this.ref.detectChanges();
      return;
    }
    this.selectedAll = false;
    if (this.loader instanceof LoaderComponent) {
      this.loader.show();
    }
    this.ref.markForCheck();
    this.fitmentsService.fetchYmmPredictiveSearch(
      searchString,
      this.searchModel.currentPage,
      this.searchModel.perPage,
    )
    .pipe(takeWhile(() => this.isActive))
    .subscribe((res: any) => {
      this.searchModel.lastPage = res.last_page;
      this.searchModel.searchString = searchString;
      this.data = _.map(res.data, (item: any) => {
        item.selected = _.some(this.selectedData, ['id', item.id]);
        return item;
      });
      if (this.loader instanceof LoaderComponent) {
        this.loader.hide();
      }
      this.ref.markForCheck();
    });
  }

  public resetData() {
    super.resetData();
    this.selectedData = [];
    this.searchModel = new SearchModel();
    this.ref.markForCheck();
  }
}
